module.exports = __webpack_public_path__ + "img/person.1e27cc97.png";